export default __webpack_public_path__ + "250bc42.png";